import FactoryEventsPage from './FactoryEventsPage';

/** What people did: launches, edits, forks, conversions, orders, deletions. */
const ActivityPage = () => (
  <FactoryEventsPage
    kind="activity"
    title="Activity"
    subtitle="What was decided and by whom — launches, edits, forks, orders, deletions."
  />
);

export default ActivityPage;
